"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var TimeSlots = function TimeSlots(_ref) {
  var _onClick = _ref.onClick,
      pickupTime = _ref.pickupTime,
      slots = _ref.slots,
      title = _ref.title;
  return _react["default"].createElement(_style.Container, null, title && _react["default"].createElement(_style.Title, null, title), _react["default"].createElement(_style.Slots, {
    length: slots.length
  }, slots.map(function (slot) {
    return _react["default"].createElement(_style.Slot, {
      active: pickupTime === slot.from,
      "data-test-id": "slot",
      "data-test-day": slot.date,
      disabled: !slot.available,
      key: "slot-".concat(slot.from),
      onClick: function onClick() {
        return slot.available && _onClick(slot.from);
      },
      onKeyPress: function onKeyPress() {
        return slot.available && _onClick(slot.from);
      },
      role: "link",
      tabIndex: 0
    }, "".concat(slot.from, " - ").concat(slot.to));
  })));
};

TimeSlots.propTypes = {
  title: _propTypes["default"].string,
  error: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  pickupTime: _propTypes["default"].string,
  slots: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
TimeSlots.defaultProps = {
  error: false,
  title: undefined,
  pickupTime: undefined,
  onClick: function onClick() {}
};
var _default = TimeSlots;
exports["default"] = _default;